import qs from 'qs'
import instance from '@/helpers/axios'
import moment from 'moment'
import numeral from 'numeral'

const state = {
	rows:0,
	data_this_year:[],
	data_last_year:[],
	option:{
		year: null,
	}
}

// getters
const getters = {
	'data_last_year': state => {
        return state.data_last_year;
	},
	'data_this_year': state => {
        return state.data_this_year;
	}
}

// actions
const actions = {
    getGdpTableDataSets(context, payload) {

		const params1 = {
			params: {
				limit:1,
				sort:'-gdp_year',
			}
		};

		let year = null;
		if (payload.main_filters !='undefined' && payload.main_filters.year !='undefined') {
			year = payload.main_filters.year;
		}
		
		if (year != null) {
			params1.params.year = year;
		}
    instance.get('tourist/gdp',params1).then((response) => {
			
			let gdp_year = (response.data.rows[0].gdp_year != 'undefined' && response.data.rows[0] != 'undefined') ? response.data.rows[0].gdp_year : Date();
			state.option.year = gdp_year;

			const params_this_year = {
				params:{
					year:gdp_year,
				}
			};
			instance.get('tourist/gdp',params_this_year).then((response) => {
				
				state.data_this_year= typeof response.data !='undefined' ? response.data.rows : [];
					context.commit("onThisYear", payload);
				}).catch((error) => {
        if (error.response) {
					console.log(error.response.data);
				}
			});
			
			const params_last_year={
				params:{
					year:gdp_year-1,
				}
			};
			instance.get('tourist/gdp',params_last_year).then((response) => {
					state.data_last_year= typeof response.data !='undefined' ? response.data.rows : [];
					context.commit("onLastYear", payload);
			}).catch((error) => {
        if (error.response) {
					console.log(error.response.data);
				}
			});
		});
	}
}

// mutations
const mutations = {
	onThisYear(state, payload) {
		//console.log('onThisYear',state.items);
	},
	onLastYear(state, payload) {
		//console.log('onLastYear',state.items);
	}
}

export default {
    state,
    getters,
    actions,
    mutations
}